import { settingAPI } from "../settingAPI.service";

export const updateQuery = ( {
	                             locale,
	                             newUsers
                             }: any ) => settingAPI.util.updateQueryData( 'fetchAllUsers',
	( { locale } ), ( draft: any ) => {
		Object.assign( draft, { users: newUsers } )
	} )